import { useState, useEffect } from "react"; // 1. Added useEffect
import { createPortal } from "react-dom";
import axios from 'axios';
import "../styles/EditModel.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export default function EditModal({ patient, onClose, onSaveSuccess }) {
  const firstStudy  = patient?.studies?.[0] || {};
  const editDetail  = firstStudy?.edit_detail || {};
  const reportStatus = firstStudy?.report_status || "open";
  const isReadOnly   = reportStatus === "signed_off";
  const [form, setForm] = useState({
    patientName:        patient?.patient_name        || "",
    patientAge:         patient?.patient_age         || "",
    patientId:          patient?.patient_id          || "",
    patientUHID:        patient?.patient_uhid        || "",
    patientGender:      patient?.patient_gender      || "",
    studyName:          patient?.study_description|| "",
    referringPhysician: patient?.referring_physician    || "",
    accessionNumber:    patient?.accession_number       || "",
    history:            patient?.patient_histories[0]?.history_text   || "",
  });
  useEffect(() => {
    if (patient) {
      setForm({
        patientName:        patient.patient_name         || "",
        patientAge:         patient.patient_age          || "",
        patientId:          patient.patient_id           || "",
        patientUHID:        patient.patient_uhid         || "",
        patientGender:      patient.patient_gender       || "",
        studyName:          patient.study_description || "",
        referringPhysician: patient?.referring_physician || "",
        accessionNumber:    patient?.accession_number     || "",
        history:            patient?.patient_histories[0]?.history_text || "",
      });
    }
  }, [patient]);
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState({ text: "", type: "" });

  const handleChange = (e) => {
    if (isReadOnly) return;
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (isReadOnly) return;
    setSaving(true);
    setSaveMsg({ text: "", type: "" });
    console.log(patient,'check study id')
    try {
      await axios.patch(
        `${BASE_URL}/api/study-details/${patient.study_id}/`,
        {
          patient_name: form.patientName,
          patient_age: form.patientAge,
          patient_gender: form.patientGender,
          patient_uhid: form.patientUHID,
          accession_number: form.accessionNumber,
          referring_physician: form.referringPhysician,
          history_text: form.historyText,
        }
      );
      setSaveMsg({ text: "Patient details updated successfully!", type: "success" });
      setTimeout(() => {
        onSaveSuccess?.(); 
        onClose();
      }, 1000);
    } catch (err) {
      console.error("Save Error:", err);
      const errorMessage =
        err.response?.data?.errors ? JSON.stringify(err.response.data.errors) :
        err.response?.data?.message || "Patient update failed";
      setSaveMsg({ text: errorMessage, type: "error" });
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className="med-modal-overlay" onClick={onClose}>
      <div className="med-modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="med-modal-header">
          <div>
            <span className="med-tag">Patient Profile</span>
            <h2 className="med-modal-title">{form.patientName || "Unnamed Patient"}</h2>
          </div>
          <button className="med-close-x" onClick={onClose}>&times;</button>
        </div>
        {isReadOnly && (
          <div className="med-banner-readonly">
            🔒 This study is <strong>Signed Off</strong>. Editing has been locked.
          </div>
        )}
        <div className="med-modal-body">
          <h3 className="med-section-title">Demographics & Identity</h3>
          <div className="med-modal-grid">
            <div className="med-field">
              <label>Patient Name *</label>
              <input name="patientName" value={form.patientName} onChange={handleChange} disabled={isReadOnly} />
            </div>
            <div className="med-field">
              <label>Patient ID *</label>
              <input name="patientId" value={form.patientId} onChange={handleChange} disabled={isReadOnly} />
            </div>
            <div className="med-field">
              <label>Age</label>
              <input name="patientAge" value={form.patientAge} onChange={handleChange} disabled={isReadOnly} />
            </div>
            <div className="med-field">
              <label>Gender</label>
              <input name="patientGender" value={form.patientGender} onChange={handleChange} disabled={isReadOnly} />
            </div>
            <div className="med-field">
              <label>Patient UHID</label>
              <input name="patientUHID" value={form.patientUHID} onChange={handleChange} disabled={isReadOnly} />
            </div>
            <div className="med-field">
              <label>Accession Number</label>
              <input name="accessionNumber" value={form.accessionNumber} onChange={handleChange} disabled={isReadOnly} />
            </div>
          </div>
          <h3 className="med-section-title" style={{ marginTop: '24px' }}>Clinical & Study Information</h3>
          <div className="med-modal-grid">
            <div className="med-field">
              <label>Study Name</label>
              <input name="studyName" value={form.studyName} onChange={handleChange} disabled={isReadOnly} />
            </div>
            <div className="med-field">
              <label>Referring Physician</label>
              <input name="referringPhysician" value={form.referringPhysician} onChange={handleChange} disabled={isReadOnly} />
            </div>
          </div>
          <div className="med-field full-width" style={{ marginTop: '16px' }}>
            <label>Clinical History</label>
            <textarea name="history" value={form.history} onChange={handleChange} disabled={isReadOnly} rows="3" placeholder="Enter clinical history notes..." />
          </div>
        </div>
        {saveMsg.text && (
          <div className={`med-status-msg ${saveMsg.type}`}>
            {saveMsg.type === "success" ? "✓ " : "⚠️ "} {saveMsg.text}
          </div>
        )}
        <div className="med-modal-footer">
          <button className="med-btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="med-btn-primary" onClick={handleSave} disabled={isReadOnly || saving}>
            {saving ? "Saving Changes..." : "Save Details"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}